import { useQuery } from '@tanstack/react-query'
import { getConsultationCancellationReasons } from '@/modules/MyCalls/my-calls-services'

export const useCancelationReasons = (enabled: boolean) => {
  const twentyFourHoursInMs = 1000 * 60 * 60 * 24

  return useQuery({
    queryKey: ['cancelation-reasons'],
    queryFn: async () => {
      return await getConsultationCancellationReasons()
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: twentyFourHoursInMs,
    enabled,
  })
}
